<template>
  <async-btn
    :task="task"
    icon="fa fa-trash-alt"
    title="Remove post from report"
    v-bind="$attrs"
    @click="trash"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReportPost } from '@/type';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { trash } from './report-post';

interface Data {
  task: Promise<ReportPost>|null,
}

export default defineComponent({
  emits: ['trashed'],
  components: { AsyncBtn },
  props: {
    reportPost: {
      type: Object as () => ReportPost,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    trash() {
      this.task = trash(this.reportPost);
      this.task.then((reportPost: ReportPost) => {
        this.$emit('trashed', reportPost);
      });
    },
  },
});
</script>
